/**
 * The last answer of a page's DigitalOcean read, kept in memory while Trace Admin stays open, so going back to Health,
 * Apps or an app shows its last answer at once instead of reading again. A page reads again only when its remembered
 * answer is older than its refresh interval (READ_MEMORY_FRESH_MS). Never stored: a reload or sign-out starts empty.
 */
export const READ_MEMORY_FRESH_MS = 30_000;

const answers = new Map<string, { value: unknown; at: number }>();

export function recallRead<T>(key: string): { value: T; at: number } | undefined {
  return answers.get(key) as { value: T; at: number } | undefined;
}

export function rememberRead(key: string, value: unknown): void {
  answers.set(key, { value, at: Date.now() });
}

/** Forgets one remembered answer (its read failed). */
export function forgetRead(key: string): void {
  answers.delete(key);
}

/**
 * Forgets every remembered answer: after an app operation (Health and Apps must not show the app as it was before it)
 * and when the session can no longer read.
 */
export function forgetReads(): void {
  answers.clear();
}
